import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import tracker from './tracker';

export default function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    tracker.pageView(location.pathname, document.title);
  }, [location.pathname]);
}
